import { render, staticRenderFns } from "./AtomText.vue?vue&type=template&id=ba919b8e&scoped=true"
import script from "./AtomText.vue?vue&type=script&setup=true&lang=js"
export * from "./AtomText.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba919b8e",
  null
  
)

export default component.exports